import { useTranslation } from 'react-i18next';
import Layout from '@/components/feature/Layout';
import Hero from './components/Hero';
import CategoriesSection from './components/CategoriesSection';
import WhatIs from './components/WhatIs';
import Benefits from './components/Benefits';
import Checklist from './components/Checklist';
import Guides from './components/Guides';
import ArticlesSection from './components/ArticlesSection';
import Faq from './components/Faq';
import FinalCta from './components/FinalCta';

export default function Home() {
  const { t } = useTranslation();

  const siteUrl = (import.meta.env.VITE_SITE_URL || 'https://usfanssheet.beer').replace(/\/$/, '');

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'USFans Spreadsheet',
    url: siteUrl,
    description: 'Independent informational resource for USFans Spreadsheet research, reviews, QC and shipping guides.',
  };

  return (
    <Layout>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }} />

      <div className="bg-background-50 text-foreground-900">
        <div className="border-b border-background-200 bg-accent-50 py-2 text-center">
          <p className="px-4 text-xs font-medium text-foreground-700">{t('home.announcement')}</p>
        </div>

        <Hero />
        <CategoriesSection />
        <WhatIs />
        <Benefits />
        <Checklist />
        <Guides />
        <ArticlesSection />
        <Faq />
        <FinalCta />
      </div>
    </Layout>
  );
}